import { render, staticRenderFns } from "./editions.vue?vue&type=template&id=32f294e0&"
import script from "./editions.vue?vue&type=script&lang=js&"
export * from "./editions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports